import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  beneLookUp,
  viewAccountDetail,
} from "../../../../redux/features/verifyPAN/verifyPAN";
import StatusContainer from "../../../../components/_utils/CommonStatus/StatusContainer";
import TabsWeapperSection from "../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import InfoCard from "../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import CommonToast from "../../../../components/_utils/CommonToast";
import {
  beneBankLookUp,
  beneDeniedAccount,
  beneWaitingApproved,
} from "../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";

import SmallPopupWithInput from "../../../../components/_utils/CommonSmallPopupWithInput";
import ICONS from "../../../../assets/Icons";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import { setHideBreadCrumb } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";

function FieldForceBankEditSuccess() {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [currentAccountDetails, setCurrentAccountDetails] = useState({
    id: "",
    name: "",
    bank_name: "",
    bank_acc_no: "",
    ifsc_code: "",
    category: "",
    pan: "",
    labels: "",
  });

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  const { viewAccountDetailData } = useSelector((state) => state.verify);

  const beneLookData = useSelector((state) => state.verify);

  const benebankLookData = useSelector(
    (state) => state.beneAllVerification.beneLookData,
  );

  const accountData = viewAccountDetailData?.beneficiary_accounts[0];

  useEffect(() => {
    if (accountData) {
      const {
        id,
        name,
        bank_name,
        bank_acc_no,
        ifsc_code,
        category,
        pan_no,
        labels,
      } = accountData;
      setCurrentAccountDetails({
        id,
        name,
        bank_name,
        bank_acc_no,
        ifsc_code,
        category,
        pan: pan_no,
        labels: labels,
      });
    }
  }, [accountData]);

  const createTxn = () => {
    CommonToast({
      text: "Feature coming soon",
      icon: "https://q2pay.in/new_assets/common/detail_page/info.svg",
      variant: "var(--coming-soon)",
      buttonNeeded: false,
    });
  };
  const createAccount = () => {
    navigate("/field_force_account_dashboard/create_field_force_account", {
      state: currentAccountDetails,
    });
  };

  const viewDetailsHandler = () => {
    navigate(
      `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/${id}`,
    );
  };

  const dashboardHandler = () => {
    navigate("/field_force_account_dashboard");
  };

  useEffect(() => {
    dispatch(viewAccountDetail({ id }));
  }, [id, dispatch]);

  useEffect(() => {
    if (!accountData) return;

    dispatch(beneLookUp({ pan_number: accountData.pan_no }));

    dispatch(
      beneBankLookUp({
        ifsc: accountData.ifsc_code,
        bank_account_no: accountData.bank_acc_no,
      }),
    );
  }, [accountData, dispatch]);
  const buttonRows = [
    [
      {
        btnText: "Create account",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: "https://q2pay.in/new_assets/common/create_flow/create_new_account.svg",
        handleFunction: createAccount,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
      {
        btnText: "Create transaction",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: "https://q2pay.in/new_assets/common/settings/add_button_white.svg",
        handleFunction: createTxn,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
      {
        btnText: "View details",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS.VIEW_DETAILS,
        handleFunction: viewDetailsHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
    ],

    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS.DASHBOARD,
        handleFunction: dashboardHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
      },
    ],
  ];

  return (
    <div>
      <StatusContainer
        status="success"
        buttonRows={buttonRows}
        title={
          "Old account archived and new account added to the list of active accounts successfully."
        }
      >
        <TabsWeapperSection title="Account details">
          <>
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountData?.category,
                  leftSubTitle: "Assigned categories",
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountData?.name,
                  leftSubTitle: "Account name",
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountData?.pan_no,
                  leftSubTitle: "PAN number",
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountData?.bank_acc_no,
                  leftSubTitle: "Account number",
                  ifsc: accountData?.ifsc_code,
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountData?.ifsc_code,
                  leftSubTitle: "IFSC code",
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountData?.contact_no,
                  leftSubTitle: "Contact number",
                  icon: ICONS.CONTACT_NO,
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountData?.email_id,
                  leftSubTitle: "Email ID",
                  icon: ICONS.GMAIL_RED_ERROR,
                },
              ]}
            />

            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: "Will come from API",
                  leftSubTitle: "Linked user",
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: "Will come from API",
                  leftSubTitle: "Transaction limit",
                },
              ]}
            />
          </>
        </TabsWeapperSection>
        {beneLookData?.beneLookData?.beneficiary_accounts.length >
          GlobalConfiguration.lengthCheckOne && (
          <TabsWeapperSection title="Accounts Associated to PAN">
            {beneLookData?.beneLookData?.beneficiary_accounts
              ?.filter(
                (accountData) =>
                  accountData?.approval_status === "pending" ||
                  accountData?.approval_status === "approved",
              )
              .map((accountData, id) => (
                <InfoCard
                  key={id}
                  bgColor="var(--positive-card)"
                  header={true}
                  borderColor="var(--positive-bg)"
                  rightHeaderText={`${
                    accountData?.approval_status?.charAt(0).toUpperCase() +
                    accountData?.approval_status?.slice(1)
                  } account`}
                  rightHeaderTextColor="var(--text-secondary)"
                  leftHeaderText={accountData?.bank_account_holder_full_name}
                  leftHeaderWidth="w-width-lg"
                  rows={[
                    {
                      leftTitle: accountData?.bank_acc_no,
                      leftSubTitle: "Bank account number",
                      ifsc: accountData?.ifsc_code,
                    },
                  ]}
                />
              ))}
          </TabsWeapperSection>
        )}

        {benebankLookData?.beneficiary_accounts?.length >
          GlobalConfiguration.lengthCheckOne && (
          <TabsWeapperSection title="Accounts Associated to Bank">
            {benebankLookData?.beneficiary_accounts
              .filter(
                (accountData) =>
                  accountData?.approval_status === "pending" ||
                  accountData?.approval_status === "approved",
              )
              .map((accountData, id) => (
                <InfoCard
                  key={id}
                  bgColor="var(--positive-card)"
                  header={true}
                  borderColor="var(--positive-bg)"
                  rightHeaderText={`${
                    accountData?.approval_status?.charAt(0).toUpperCase() +
                    accountData?.approval_status?.slice(1)
                  } account`}
                  rightHeaderTextColor="var(--text-secondary)"
                  leftHeaderText={accountData?.name}
                  leftHeaderWidth="w-width-lg"
                  rows={[
                    {
                      leftTitle: accountData?.pan_no,
                      leftSubTitle: "PAN number",
                    },
                  ]}
                />
              ))}
          </TabsWeapperSection>
        )}
      </StatusContainer>
    </div>
  );
}

export default FieldForceBankEditSuccess;
